// Vendor
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// House
import { EnvironmentUtilService } from '../util';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class ManageApiService {
  environment = this.environmentUtilService.getEnvironment();

  constructor(
    private apiService :ApiService,
    private environmentUtilService :EnvironmentUtilService,
  ) {}

  getCustomFieldsMapping() :Observable<any> {
    return this.apiService.get(
      `${this.environment.urlV2}/manage/custom-fields/sales-order`,
    );
  }
}
